import * as ActionType from 'redux/actions/types'
import {
  ADDITIONAL_SEARCHBAR_SELECTS,
  BOOKABLE_TYPES,
  entryPointId,
} from 'settings/app/constants'

/**
 * parsing bookable elements and return clean, initial state
 * @returns {{}}
 */
const getInitialStateForBookableElements = () => {
  const initialResultState = {}

  BOOKABLE_TYPES.forEach((element) => {
    switch (element) {
      case entryPointId.HOSPITALS:
        initialResultState[element] = {
          searchParams: {
            key: '',
            type: '',
            query: '',
          },
          items: [],
          count: 0,
          activeSort: 'alphabetical', // feature implementation (improves bookmark)
        }
        break

      case entryPointId.CAREHOMES:
      case entryPointId.CARESERVICES:
      case entryPointId.DAYANDNIGHTCARE:
        const stateKeys = {}
        Object.keys(ADDITIONAL_SEARCHBAR_SELECTS[element]).forEach((param) => {
          stateKeys[ADDITIONAL_SEARCHBAR_SELECTS[element][param].typ] = ''
        })
        initialResultState[element] = {
          searchParams: {
            ...stateKeys,
          },
          items: [],
          count: 0,
          activeSort: 'alphabetical',
        }
        break

      default:
        initialResultState[element] = {
          searchParams: {
            key: '',
            type: '',
          },
          items: [],
          count: 0,
          activeSort: 'alphabetical',
        }
    }
  })

  return initialResultState
}

/**
 * INITIAL STATE OBJECT
 * @type {{types: {}, overlay: {bookmarkToAdd: null, show: boolean}, selectedDetails: null, totalCount: number}}
 */
export const INITIAL_STATE = {
  types: getInitialStateForBookableElements(),
  totalCount: 0,
  selectedDetails: null,
  overlay: {
    show: false,
    bookmarkToAdd: null,
  },
}

/**
 * reducer
 * @param state
 * @param action
 * @returns {{types: {}, overlay: {bookmarkToAdd: null, show: boolean}, selectedDetails: null, totalCount: (number|{excludeBookmarkTyp: *, bookmarkState: *}|{bookmarkState: *}|number|*)}|{types: {}, overlay: {bookmarkToAdd: null, show: boolean}, selectedDetails, totalCount: number}|{types: {}, overlay: {bookmarkToAdd: null, show: boolean}, selectedDetails: null, totalCount: number}|{types: {}, overlay: {bookmarkToAdd, show: boolean}, selectedDetails: null, totalCount: number}|{types: {}, overlay: {bookmarkToAdd: null, show: boolean}, selectedDetails: null, totalCount}|{types: {}, overlay: {bookmarkToAdd: null, show: boolean}, selectedDetails: {count, results: *}, totalCount: number}}
 */
const bookmarkReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionType.SHOW_BOOKMARK_OVERLAY:
      return {
        ...state,
        overlay: {
          show: true,
          bookmarkToAdd: action.payload,
        },
      }

    case ActionType.HIDE_BOOKMARK_OVERLAY:
      return {
        ...state,
        overlay: {
          show: false,
          bookmarkToAdd: null,
        },
      }

    case ActionType.REMOVE_BOOKMARK_FROM_DETAILS:
      if (!state.selectedDetails) return state

      const filteredItems = state.selectedDetails.results?.filter(
        (item) => item.id !== action.payload
      )
      const newDetails = {
        ...state.selectedDetails,
        count: filteredItems.length,
        results: filteredItems,
      }
      return {
        ...state,
        selectedDetails: newDetails,
      }

    case ActionType.TOGGLE_BOOKMARK:
      const { id, type, reset, totalCount, bookmarkParams } = action.payload
      const clonedItems = [...state.types[type].items]
      const idIndex = clonedItems.indexOf(id)

      // remove bookmark if exists
      if (idIndex > -1) {
        clonedItems.splice(idIndex, 1)
      }

      // add or remove bookmark id && update current bookmark count
      const items =
        idIndex > -1 ? clonedItems : reset ? [id] : [...clonedItems, id]
      const count = Object.keys(items).length

      return {
        ...state,
        types: {
          ...state.types,
          [type]: {
            searchParams: bookmarkParams,
            count,
            items,
          },
        },
        totalCount,
      }

    case ActionType.FETCH_BOOKMARKS_COMPLETE:
      return {
        ...state,
        selectedDetails: action.payload.selectedDetails,
        types: {
          ...state.types,
          [action.payload.type]: {
            ...state.types[action.payload.type],
            searchParams: action.payload.searchParams,
            items: action.payload.items,
          },
        },
      }

    case ActionType.CLEAR_BOOKMARK_DETAILS:
      return {
        ...state,
        selectedDetails: null,
      }

    // remove id from items array based on type (hospitals or doctors)
    case ActionType.REMOVE_ONE_BOOKMARK:
      return {
        ...state,
        types: {
          ...state.types,
          [action.payload.type]: {
            ...state.types[action.payload.type],
            count: action.payload.items.length,
            items: [...action.payload.items],
          },
        },
        totalCount: action.payload.totalCount,
      }

    default:
      return state
  }
}

export default bookmarkReducer
